module.exports = __webpack_public_path__ + "sky.jpg?c5fb4262ea036dd58d4eadfd8e659a42";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sky.jpg
// module id = 137
// module chunks = 0